module.exports = __webpack_public_path__ + "img/usage_auto.6686968a.png";